import React from "react";
import ResponsiveImg, { SIZES } from "./ResponsiveImg";
import Link from "./LocalizedLink";
import { useI18n } from "../i18n/I18nProvider";
import { ArrowUpRight } from "lucide-react";

export default function DevelopmentCard({ d, index = 0 }) {
  const { t } = useI18n();
  return (
    <Link
      to={`/developments/${d.slug}`}
      data-testid={`development-card-${d.slug}`}
      className="group flex flex-col cursor-pointer border-b border-[#E5DFD5] pb-10"
    >
      <div className="aspect-[4/3] overflow-hidden mb-7 bg-[#E5DFD5]">
        <ResponsiveImg
          src={d.image}
          sizes={SIZES.card}
          alt={`${d.name} at Finca Cortesin`}
          loading={index < 3 ? "eager" : "lazy"}
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
        />
      </div>
      <div className="flex items-start justify-between gap-4 mb-2">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#73706B]">
          {d.propertyType}
        </p>
        <ArrowUpRight
          className="w-4 h-4 text-[#1A1A1A] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 shrink-0"
          strokeWidth={1.25}
        />
      </div>
      <h3
        className="text-2xl lg:text-3xl text-[#1A1A1A] font-light leading-tight mb-3 group-hover:text-[#C5A880] transition-colors duration-300"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        {d.name}
      </h3>
      <p className="text-base text-[#73706B] leading-relaxed mb-5 line-clamp-2">
        {d.tagline}
      </p>
      <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2 text-[11px] tracking-[0.2em] uppercase text-[#73706B] mt-auto">
        <span>{t("from")}</span>
        <span className="text-[#C5A880] text-base tracking-normal normal-case">
          {d.priceFrom}
        </span>
        <span className="ml-auto">{d.bedrooms} {t("bed")}</span>
      </div>
    </Link>
  );
}
